import { FC, ReactNode } from "react";

import styles from "./form.module.css";

interface Props {
  children: ReactNode;
  onClose: () => void;
}

// Итоговое сообщение формы (например, об успехе) с кнопкой закрытия.
export const FormNotice: FC<Props> = ({ children, onClose }) => (
  <div className={styles.form}>
    <p className={styles.status}>{children}</p>
    <button type="button" className={styles.submitButton} onClick={onClose}>
      Close
    </button>
  </div>
);
